import {forward, sample} from 'effector';

import {RestError, showRestError} from 'core/errors';

import {addFactoriesBatchFx} from '../factoryOperations';

import {data$, fetchDataFx, Gate} from './index';

data$.on(fetchDataFx.doneData, (_, data) => data);

forward({
    from: Gate.open,
    to: fetchDataFx,
});

sample({
    clock: addFactoriesBatchFx.done,
    target: fetchDataFx,
});

fetchDataFx.fail.watch(({error}) => showRestError(error as RestError));
